module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q8-lockup.750bb66d.png";